import DeleteIcon from "@mui/icons-material/Delete";
import { Alert, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { useFormContext } from "react-hook-form";

type Option = {
    id: string;
    name: string;
};

const AssignCasesDisplay = () => {
    const { watch, setValue } = useFormContext();
    const formValue = watch("cases");

    const handleDelete = (id: string) => {
        if (formValue) {
            const newTasks = formValue.filter((task: Option) => task.id !== id);
            setValue("cases", newTasks);
        }
    };

    return (
        <>
            {formValue && !formValue.length && (
                <Alert severity={"warning"}>No cases assigned.</Alert>
            )}
            <List>
                {formValue?.map((task: Option) => {
                    return (
                        <ListItem
                            key={task.id}
                            secondaryAction={
                                <IconButton
                                    edge="end"
                                    aria-label="delete"
                                    onClick={() => handleDelete(task.id)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            }
                        >
                            <ListItemText primary={task.name} />
                        </ListItem>
                    );
                })}
            </List>
        </>
    );
};

export default AssignCasesDisplay;
